<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "app",
  watch: {
    ["$i18n.locale"]() {
      this.$store.commit("setState", { key: "lang", value: this.$i18n.locale });
    }
  },

};
</script>

<style lang="less" scoped>
#app {
  overflow-x: hidden;
  background: #F5F5F5;
}
p{
  margin: 0;
  padding: 0 
}
</style>

<style>
.relative {
  position: relative;
}
/* 解决错误信息不需要关闭按钮 */
.ant-notification-notice-close {
  display: none !important;
}
</style>

